import React from 'react';
import { Text } from '../../components';
import { Button } from '@kmx/legos-react-button';
import FailureGraphic from './images/failure-graphic';

const FailurePage = () => {
  return (    
    <div className='text-center p-t-xxl m-t-l'>
      <FailureGraphic />
      <Text.Display1>
        We&apos;re sorry; you have exceeded the limit of three identity verification requests within a 24 hour period.  If you believe
        an error was made in this identity verification, you may submit an appeal to CarMax <a href="/privacy-policy/your-data#appeal">here</a>.
      </Text.Display1>
      <Text.Body2>Please try again in 24 hours</Text.Body2>
      <Button
        className='m-t-l p-l-xxl p-r-xxl'
        full={true}
        level='primary'
        type='button'
        onClick={() => {
          window.location.href = '/privacy-policy';
        }}>
        Return to Privacy Policy
      </Button>
    </div>
  );
};

export default FailurePage;
